import Header from "./Header";
import Footer from "./Footer";
import "../styles/legacy-layout.css";
import "../styles/react-overrides.css";
import { useLocation } from "react-router-dom";

function Layout({ children }) {
  const location = useLocation();
  const flushPaths = [
    "/",
    "/Services",
    "/Knowledge-Center",
    "/Knowledge-Centre",
    "/About-us",
    "/Contact-us",
    "/privacypolicy",
    "/termsconditions",
    "/Report",
    "/SelfAssessment",
    "/Assessment",
    "/Assessment/report",
    "/thank-you",
    "/RiskEngineering",
    "/Strata",
    "/PortfolioAnalyticsandDataInsights",
    "/CrisisManagementandBusinessContinuity",
  ];
  const isFlush = flushPaths.includes(location.pathname);

  return (
    <div className="pr-react-app">
      <Header />
      <main className={`pr-page-content ${isFlush ? "pr-page-content--flush" : ""}`}>{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;